import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaTwitter, FaLinkedin, FaTelegram, FaDiscord } from 'react-icons/fa';

const Footer = () => {
  const { t } = useTranslation();
  
  const navigation = {
    main: [
      { name: t('nav.home', '首页'), href: '/' },
      { name: t('nav.about', '关于我们'), href: '/about' },
      { name: t('nav.services', '服务介绍'), href: '/services' },
      { name: t('nav.technology', '技术与策略'), href: '/technology' },
      { name: t('nav.performance', '业绩与案例'), href: '/performance' },
      { name: t('nav.compliance', '合规与安全'), href: '/compliance' },
      { name: t('nav.news', '新闻动态'), href: '/news' },
      { name: t('nav.contact', '联系我们'), href: '/contact' },
    ],
    legal: [
      { name: t('footer.legal.privacy', '隐私政策'), href: '/privacy' },
      { name: t('footer.legal.terms', '用户协议'), href: '/terms' },
      { name: t('footer.legal.disclaimer', '免责声明'), href: '/disclaimer' },
      { name: t('footer.legal.faq', '常见问题'), href: '/faq' },
    ],
    social: [
      {
        name: 'Twitter',
        href: '#',
        icon: FaTwitter,
      },
      {
        name: 'LinkedIn',
        href: '#',
        icon: FaLinkedin,
      },
      {
        name: 'Telegram',
        href: '#',
        icon: FaTelegram,
      },
      {
        name: 'Discord',
        href: '#',
        icon: FaDiscord,
      },
    ],
  };

  return (
    <footer className="bg-secondary text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-xl font-bold mb-4">9527 Finance</h3>
            <p className="text-gray-300">
              {t('footer.companyDesc', '领先的加密资产做市商，为交易所和项目方提供稳定可靠的流动性解决方案。')}
            </p>
          </div>

          {/* Main Navigation */}
          <div>
            <h3 className="text-lg font-semibold mb-4">{t('footer.quickLinks', '快速链接')}</h3>
            <ul className="space-y-2">
              {navigation.main.map((item) => (
                <li key={item.name}>
                  <Link
                    to={item.href}
                    className="text-gray-300 hover:text-white transition-colors"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">{t('footer.legalInfo', '法律信息')}</h3>
            <ul className="space-y-2">
              {navigation.legal.map((item) => (
                <li key={item.name}>
                  <Link
                    to={item.href}
                    className="text-gray-300 hover:text-white transition-colors"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact & Social */}
          <div>
            <h3 className="text-lg font-semibold mb-4">{t('footer.contactUs', '联系我们')}</h3>
            <div className="space-y-4">
              <div>
                <p className="text-gray-300">{t('footer.email', '邮箱')}: stanley@9527.fi</p>
                <p className="text-gray-300">{t('footer.address', '地址')}: {t('footer.addressValue', '新加坡金融区')}</p>
              </div>
              <div className="flex space-x-4">
                {navigation.social.map((item) => (
                  <a
                    key={item.name}
                    href={item.href}
                    className="text-gray-300 hover:text-white transition-colors"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="sr-only">{item.name}</span>
                    <item.icon className="h-6 w-6" />
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-200 mt-12 pt-8">
          <p className="text-center text-gray-500">
            © 2018-2025 9527.fi. {t('footer.copyright', 'All rights reserved.')}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 